import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/interazioniEmail';
import { selectors, DEFAULT_STATE } from '../reducers/interazioniEmail';
import api from '../apis/interazioniEmail';

const sagas = helper.createSagas(
    'interazioniEmail',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
